import React, { useMemo } from 'react'
import Seo from '../Seo'

const env = (typeof process !== 'undefined' && process.env) || {}

const DEFAULTS = {
  embedUrl: 'https://app.leanit101.com/benjamin',
  embedToken:
    'eyJvcmdhbml6YXRpb25JZCI6NDAsImFnZW50U2x1ZyI6Im5leHQtY3JlZGl0LXNhbGVzLWFzc2lzdGFudCIsInRlbmFudFNsdWciOiJuZXh0LWNyLWRpdG8taW1vYmlsaS1yaW8iLCJhc3Npc3RhbnROYW1lIjoiUmFmYWVsIiwibWV0YWRhdGEiOnsiY2hhbm5lbERlZmF1bHQiOiJ3ZWJfZW1iZWQifX0.6660a13ee1acfb81bed6ed6aefa90989fb8e94c02aedd9237714b9c2ab7e9085',
  agentSlug: 'next-credit-sales-assistant',
  tenantSlug: 'next-cr-dito-imobili-rio',
  organizationId: '40',
  assistantName: 'Rafael',
  channel: 'web_embed',
  utmSource: 'leanit101.com',
  utmCampaign: 'next-sales-credito-poc',
}

const NextSalesCreditoPage = () => {
  const queryParams = useMemo(() => {
    if (typeof window === 'undefined') return new URLSearchParams('')
    return new URLSearchParams(window.location.search || '')
  }, [])

  const embedToken =
    queryParams.get('token') ||
    env.REACT_APP_NEXT_SALES_CREDITO_EMBED_TOKEN ||
    DEFAULTS.embedToken

  const agentSlug =
    queryParams.get('agentSlug') ||
    env.REACT_APP_NEXT_SALES_CREDITO_AGENT_SLUG ||
    DEFAULTS.agentSlug

  const resolvedTenant =
    queryParams.get('tenantSlug') ||
    env.REACT_APP_NEXT_SALES_CREDITO_TENANT_SLUG ||
    DEFAULTS.tenantSlug
  const tenantSlug = resolvedTenant.toString().trim().toLowerCase()

  const orgId =
    queryParams.get('organizationId') ||
    env.REACT_APP_NEXT_SALES_CREDITO_ORGANIZATION_ID ||
    DEFAULTS.organizationId

  const assistantName =
    queryParams.get('assistantName') ||
    env.REACT_APP_NEXT_SALES_CREDITO_ASSISTANT_NAME ||
    DEFAULTS.assistantName

  const channel = queryParams.get('channel') || DEFAULTS.channel
  const utmSource = queryParams.get('utm_source') || DEFAULTS.utmSource
  const utmCampaign = queryParams.get('utm_campaign') || DEFAULTS.utmCampaign

  const iframeSrc = useMemo(() => {
    const params = new URLSearchParams()
    if (embedToken) {
      params.set('token', embedToken)
    }
    params.set('agentSlug', agentSlug)
    params.set('tenantSlug', tenantSlug)
    params.set('organizationId', orgId)
    params.set('assistantName', assistantName)
    params.set('channel', channel)
    params.set('locale', 'pt-BR')
    if (utmSource) params.set('utm_source', utmSource)
    if (utmCampaign) params.set('utm_campaign', utmCampaign)
    params.set('meta.source', 'next-sales-credito-poc')
    params.set('meta.partner', 'next-credito-imobiliario')

    const baseUrl =
      env.REACT_APP_NEXT_SALES_CREDITO_EMBED_URL || DEFAULTS.embedUrl
    return `${baseUrl}?${params.toString()}`
  }, [
    agentSlug,
    assistantName,
    channel,
    embedToken,
    orgId,
    tenantSlug,
    utmCampaign,
    utmSource,
  ])

  return (
    <section className="relative flex flex-col w-full min-h-screen overflow-hidden bg-[#060912] text-white">
      <Seo
        title="Next Crédito Imobiliário | Rafael"
        description="POC privada para validação do agente consultivo da Next Crédito Imobiliário."
        path="/next-sales-credito"
        noindex
      />
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0c1224] via-[#060912] to-[#060912]" />
        <div
          className="absolute -top-24 left-[12%] w-[620px] h-[620px] rounded-full opacity-30"
          style={{
            background:
              'radial-gradient(50% 50% at 50% 50%, rgba(56,189,248,0.28) 0%, rgba(56,189,248,0) 68%)',
            filter: 'blur(56px)',
          }}
        />
        <div
          className="absolute bottom-[-240px] right-[-120px] w-[600px] h-[600px] rounded-full opacity-24"
          style={{
            background:
              'radial-gradient(50% 50% at 50% 50%, rgba(245,158,11,0.24) 0%, rgba(245,158,11,0) 66%)',
            filter: 'blur(48px)',
          }}
        />
        <div
          className="absolute inset-0 opacity-[0.07]"
          style={{
            backgroundImage:
              'linear-gradient(to right, rgba(255,255,255,0.06) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.06) 1px, transparent 1px)',
            backgroundSize: '28px 28px',
          }}
        />
      </div>

      <div className="w-full max-w-6xl mx-auto px-4 py-12 md:py-16 space-y-8">
        <header className="text-center space-y-4">
          <p className="text-xs uppercase tracking-[0.42em] text-sky-200/70">
            Next Crédito Imobiliário
          </p>
          <h1 className="text-3xl md:text-5xl font-semibold">
            Rafael • Qualificação consultiva
          </h1>
          <p className="max-w-3xl mx-auto text-base md:text-lg text-slate-200">
            Página de POC para validar o agente que faz a primeira qualificação
            de leads de crédito imobiliário, com tom premium, consultivo e foco
            em oportunidades reais.
          </p>
        </header>

        <div className="grid gap-6 lg:grid-cols-[1.15fr_minmax(320px,0.85fr)]">
          <div className="w-full bg-slate-900/55 border border-sky-200/10 rounded-[28px] shadow-2xl overflow-hidden">
            <div className="px-5 py-4 border-b border-white/8">
              <div className="text-[11px] uppercase tracking-[0.34em] text-sky-200/68">
                Conversa ao vivo
              </div>
              <div className="mt-2 text-sm text-slate-300">
                Fluxo em português voltado para compra, investimento, perfil de
                renda, FGTS, valor do imóvel e avanço para atendimento humano ou
                reunião.
              </div>
            </div>
            <div className="relative w-full h-[560px] md:h-[660px]">
              <iframe
                title="Rafael — Next Crédito Imobiliário"
                src={iframeSrc}
                allow="clipboard-read; clipboard-write"
                className="absolute inset-0 w-full h-full"
                style={{ background: 'transparent' }}
              />
            </div>
          </div>

          <div className="grid gap-4 content-start">
            <div className="bg-white/5 border border-white/10 rounded-2xl p-5 backdrop-blur-sm">
              <div className="text-[11px] uppercase tracking-[0.3em] text-sky-200/72">
                Posicionamento
              </div>
              <h2 className="mt-3 text-xl font-semibold">
                Crédito imobiliário com orientação estratégica
              </h2>
              <p className="mt-3 text-sm text-slate-200 leading-6">
                O Rafael foi configurado para qualificar com profundidade sem
                parecer burocrático. Ele não atua como simples repasse para
                banco. Ele conduz a triagem inicial com foco em estratégia de
                crédito, capacidade de compra e continuidade qualificada.
              </p>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-2xl p-5 backdrop-blur-sm">
              <div className="text-[11px] uppercase tracking-[0.3em] text-sky-200/72">
                O que validar
              </div>
              <ul className="mt-3 space-y-3 text-sm text-slate-200 leading-6">
                <li>Se o tom transmite confiança, clareza e percepção premium.</li>
                <li>Se a coleta de dados essenciais acontece sem soar cansativa.</li>
                <li>Se ele separa curiosos de leads sérios e move bons casos adiante.</li>
              </ul>
            </div>

            <div className="bg-[#0d1322] border border-amber-300/20 rounded-2xl p-5">
              <div className="text-[11px] uppercase tracking-[0.3em] text-amber-200/78">
                Compartilhamento
              </div>
              <p className="mt-3 text-sm text-slate-200 leading-6">
                Use este link com o cliente para validação da POC:
              </p>
              <code className="mt-3 block text-xs md:text-sm break-all text-amber-200">
                https://leanit101.com/next-sales-credito
              </code>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-2xl p-5 backdrop-blur-sm">
              <div className="text-[11px] uppercase tracking-[0.3em] text-sky-200/72">
                Rastreio
              </div>
              <p className="mt-3 text-sm text-slate-200 leading-6">
                Eventos desta página chegam com <strong>organizationId 40</strong>,
                locale <strong>pt-BR</strong> e metadados específicos da POC da
                Next Crédito Imobiliário.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default NextSalesCreditoPage
